import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormArray, FormGroup } from "@angular/forms";
import {
  OnboardEducationDetails,
  OnboardEmpAdditionalQualifications,
} from "../../shared/models/OnboardEducationDetails";
import {
  MultipleFilesDialog,
  MultipleFilesDialogComponent,
} from "../../shared/components/multiple-files-dialog/multiple-files-dialog.component";
import { MatDialog } from "@angular/material";
import { FileToUpload } from "../../shared/models/filetoupload";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardEmpDoc } from "../../shared/models/OnboardEmpDoc";
import { OnboardHREmpDoc } from "../../shared/models/OnboardHREmpDoc";
import { ToastrService } from "ngx-toastr";
import { error } from "@angular/compiler/src/util";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { HrEmpEducationDetails } from "../../shared/models/hrEmpEducationDtls";
import { isUndefined, isNullOrUndefined } from "util";
import { EmployeeService } from "../../shared/service/employee.service";
import { HREmpMultipleDoc } from "../../shared/models/hrEmpMultipleDocs";
import { isObjectEmpty } from "ngx-bootstrap/chronos/utils/type-checks";
import { isNull } from "@angular/compiler/src/output/output_ast";

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import { DatePipe } from "@angular/common";
import {
  HrEmpEducationInfo,
  EmpAdditionalQualifications,
} from "../../shared/models/HrEmpEducationInfo";
import { UserService } from "../../shared/service/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { File_Types } from "../../shared/UploadFileTypes";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { OnboardEmpEducationInformation } from "../../shared/models/OnboardEmpEducationInformation";
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-education-details",
  templateUrl: "./education-details.component.html",
  styleUrls: ["./education-details.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EducationDetailsComponent implements OnInit, OnChanges, OnDestroy {
  rows: FormArray = this.fb.array([]);
  EducationDetailForm: FormGroup = this.fb.group({ dates: this.rows });
  @Input() EmpId: number;
  @Input() empCode: number;
  educationDetails: any[] = [];
  @Output("myOutputVal") myOutputVal = new EventEmitter();
  @Output("additionalQual") additionalQual = new EventEmitter();
  MulFiles: any[] = [];
  result: any;
  error: any;
  IsExpand = true;
  newAttribute: any = {};
  empEducationInfo: any;
  originalEmpEducationInfo: any;
  parentComponentName: string;
  educationDtlsDisable: boolean = false;
  approveCheckMyProfile: any;
  LoginEmpCode: any;
  additionalQualifications: any[] = [];
  originalAdditionalQaulifications: any;
  isProfile: boolean;
  disableforMyProfile: any;
  gettingBasicDet: BasicEmployeeDetails;
  enableReqforFTELoc: boolean = true;
  MAX_SIZE: number = 1048576;
  isLoader: boolean = true;
  destroyed = false;
  private fileInputOpen = false;
  constructor(
    private route: ActivatedRoute,
    private emp_Svc: EmployeeService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private _service: OnboardingService,
    private emp_svc: EmployeeService,
    private userService: UserService,
    private toastr: ToastrService,
    private changeCom_svc: ComponentIdentificationService,
    public router: Router,
    public file_Svc: FileUploadService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
    //this.getSubmitMyProfileData();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    //this.EmpId = this.LoginEmpCode;

    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }

  ngOnChanges() {
    this.additionalQualifications = [];
    this.changeCom_svc.componentName.subscribe(
      (response) => (this.parentComponentName = response)
    );
    if (this.parentComponentName == "app-hr-employee-details") {
      this.empEducationInfo = new HrEmpEducationInfo();
      if (!isUndefined(this.empCode)) {
        this.getHREmpData();
        this.getBasicEmployeeByCode();
      } else {
        this.addItem();
        this.addAdditionalQualItem();
        this.EmitOutputValues();
      }
    } else {
      this.empEducationInfo = new OnboardEmpEducationInformation();
      this.getData();
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  addItem(item = null) {
    if (item != null) {
      const row = this.fb.group({
        ID: item.Id,
        Qualification: item.Qualification,
        MarksPercent: item.MarksPercent,
        YearOfPassing: item.YearOfPassing,
        University: item.University,
        onboardVrifications: item.onboardVrifications,
        OnboardHREmpDocs: "",
      });
      this.rows.push(row);
    } else {
      const row = this.fb.group({
        ID: null,
        Qualification: "",
        MarksPercent: "",
        YearOfPassing: null,
        University: "",
        onboardVrifications: null,
        OnboardHREmpDocs: null,
        isNew: true,
      });
      this.rows.push(row);
    }
    if (!this.destroyed) this.cdr.detectChanges();
  }

  getData() {
    if (this.EmpId != null) {
      this._service.GetOnboardEmpEducationDetails(this.EmpId).subscribe(
        (data: any) => {
          this.additionalQualifications = [];
          this.rows = this.fb.array([]);
          this.EducationDetailForm = this.fb.group({ dates: this.rows });
          if (data != null) {
            this.empEducationInfo = data;
            if (
              data.educationDetails != null &&
              data.educationDetails.length != 0
            ) {
              this.educationDetails = this.empEducationInfo.educationDetails;
              for (var i = 0; i < this.educationDetails.length; i++) {
                this.addItem(this.educationDetails[i]);
                if (
                  !isNullOrUndefined(
                    this.educationDetails[i].OnboardHREmpDocs
                  ) &&
                  this.educationDetails[i].OnboardHREmpDocs.length != 0
                ) {
                  this.MulFiles[i] = this.educationDetails[i].OnboardHREmpDocs;
                  this.rows.value[i].OnboardHREmpDocs =
                    this.educationDetails[i].OnboardHREmpDocs;
                } else {
                  this.MulFiles[i] = [];
                }
              }
            } else {
              this.addItem();
            }
            if (
              data.AdditionalQualifications != null &&
              data.AdditionalQualifications.length != 0
            ) {
              var seen = new Set();
              var row = 0;
              for (var i = 0; i < data.AdditionalQualifications.length; i++) {
                if (!seen.has(data.AdditionalQualifications[i].DocTypeName)) {
                  this.additionalQualifications[row] =
                    new OnboardEmpAdditionalQualifications();
                  this.additionalQualifications[row].Name =
                    data.AdditionalQualifications[i].DocTypeName;
                  this.additionalQualifications[row].additionalDocs =
                    this.additionalQualifications[row].additionalDocs.concat(
                      data.AdditionalQualifications[i]
                    );
                  seen.add(data.AdditionalQualifications[i].DocTypeName);
                  row++;
                } else {
                  this.additionalQualifications[row - 1].additionalDocs =
                    this.additionalQualifications[
                      row - 1
                    ].additionalDocs.concat(data.AdditionalQualifications[i]);
                }
              }
            } else {
              this.addAdditionalQualItem();
            }
          } else {
            this.addItem();
            this.addAdditionalQualItem();
          }
          this.originalEmpEducationInfo = JSON.parse(
            JSON.stringify(this.rows.value)
          );
          this.originalAdditionalQaulifications = JSON.parse(
            JSON.stringify(this.additionalQualifications)
          );
          this.EmitOutputValues();
        },
        (error) => (this.error = error)
      );
    }
  }

  getBasicEmployeeByCode() {
    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.gettingBasicDet = data;
        if (this.gettingBasicDet.ConsultantType == "SubCon") {
          this.enableReqforFTELoc = false;
        } else {
          if (
            this.gettingBasicDet.LocationID != 1 &&
            this.gettingBasicDet.LocationID != 2
          ) {
            this.enableReqforFTELoc = false;
          } else {
            this.enableReqforFTELoc = true;
          }
        }
      });
    }
  }

  getObjectState() {
    const originalDetails = this.originalEmpEducationInfo;
    const currentDetails = this.rows.value;
    this.assignDocumentsListToObject();
    var educationalVal =
      JSON.stringify(originalDetails) === JSON.stringify(currentDetails);
    const originalDoc = this.originalAdditionalQaulifications;
    const currentDoc = this.additionalQualifications;
    var addVal = JSON.stringify(originalDoc) === JSON.stringify(currentDoc);
    return !(educationalVal && addVal);
  }

  getRefreshPage() {
    window.location.reload();
  }

  getHREmpData() {
    if (this.empCode != null) {
      this.emp_svc.getEmployeeEducationalDetails(this.empCode).subscribe(
        (data: any) => {
          this.additionalQualifications = [];
          this.rows = this.fb.array([]);
          this.EducationDetailForm = this.fb.group({ dates: this.rows });
          if (data != null) {
            this.empEducationInfo = data;
            if (data.educationDetails.length != 0) {
              this.educationDetails = this.empEducationInfo.educationDetails;
              for (var i = 0; i < this.educationDetails.length; i++) {
                this.addItem(this.educationDetails[i]);
                if (
                  !isNullOrUndefined(this.educationDetails[i].HREmpDocs) &&
                  this.educationDetails[i].HREmpDocs.length != 0
                ) {
                  this.MulFiles[i] = this.convertHrEmpDocType(
                    this.educationDetails[i].HREmpDocs
                  );
                  this.rows.value[i].OnboardHREmpDocs = this.MulFiles[i];
                } else {
                  this.MulFiles[i] = [];
                }
              }
            } else {
              this.addItem();
            }
            if (data.AdditionalQualifications.length != 0) {
              var seen = new Set();
              var row = 0;
              for (var i = 0; i < data.AdditionalQualifications.length; i++) {
                if (!seen.has(data.AdditionalQualifications[i].DocTypeName)) {
                  this.additionalQualifications[row] =
                    new EmpAdditionalQualifications();
                  this.additionalQualifications[row].Name =
                    data.AdditionalQualifications[i].DocTypeName;
                  this.additionalQualifications[row].additionalDocs =
                    this.additionalQualifications[row].additionalDocs.concat(
                      data.AdditionalQualifications[i]
                    );
                  seen.add(data.AdditionalQualifications[i].DocTypeName);
                  row++;
                } else {
                  this.additionalQualifications[row - 1].additionalDocs =
                    this.additionalQualifications[
                      row - 1
                    ].additionalDocs.concat(data.AdditionalQualifications[i]);
                }
              }
            } else {
              this.addAdditionalQualItem();
            }
          } else {
            this.addItem();
            this.addAdditionalQualItem();
          }
          this.originalEmpEducationInfo = JSON.parse(
            JSON.stringify(this.rows.value)
          );
          this.originalAdditionalQaulifications = JSON.parse(
            JSON.stringify(this.additionalQualifications)
          );
          this.EmitOutputValues();
        },
        (error) => (this.error = error)
      );
    }
  }

  convertOnboardEmpDocType(array: any[]) {
    let arr: any[] = [];
    array.forEach((item) => {
      let docItem = new OnboardHREmpDoc();
      docItem.ID = item.ID;
      docItem.EmpId = item.EmpId;
      docItem.DocNumber = item.DocNumber;
      docItem.DocumentPath = item.DocumentPath;
      docItem.HRDocTypeId = item.HRDocTypeId;
      docItem.DocumentName = item.DocumentName;
      docItem.DocTypeName = item.DocTypeName;
      docItem.ModifiedBy = item.ModifiedBy;
      docItem.ModifiedDate = item.ModifiedDate;
      docItem.EducationDetailsID = item.EducationDetailsID;
      arr = arr.concat(docItem);
    });
    return arr;
  }

  convertHrEmpDocType(array: any[]) {
    let arr: any[] = [];
    array.forEach((item) => {
      let docItem = new HREmpMultipleDoc();
      docItem.ID = item.ID;
      docItem.EmpCode = item.EmpCode;
      docItem.DocNumber = item.DocNumber;
      docItem.DocumentPath = item.DocumentPath;
      docItem.HRDocTypeId = item.HRDocTypeId;
      docItem.DocumentName = item.DocumentName;
      docItem.DocTypeName = item.DocTypeName;
      docItem.ModifiedBy = item.ModifiedBy;
      docItem.ModifiedDate = item.ModifiedDate;
      docItem.EducationDetailsID = item.EducationDetailsID;
      arr = arr.concat(docItem);
    });
    return arr;
  }

  AdditionalfileCancel(i, j) {
    const message = `Please confirm if you want to remove this attachment?`;
    var deleteType = "Attachment";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          var element = this.additionalQualifications[i].additionalDocs.splice(
            j,
            1
          );
          if (element[0].DocumentPath != null) {
            if (!isUndefined(this.empCode)) {
              this.emp_svc.DeleteFileinMultipleFiles(element[0].ID).subscribe();
            } else {
              this._service
                .DeleteFileinMultipleFiles(element[0].ID)
                .subscribe();
            }
          }
          if (this.additionalQualifications[i].additionalDocs.length < 1) {
            this.additionalQualifications[i].additionalDocs = null;
          }
          this.toastr.success("Deleted Successfully");
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  fileCancel(i, j) {
    const message = `Please confirm if you want to remove this attachment?`;
    var deleteType = "Attachment";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          var element = this.MulFiles[i].splice(j, 1);
          if (element[0].DocumentPath != null) {
            if (!isUndefined(this.empCode)) {
              this.emp_svc.DeleteFileinMultipleFiles(element[0].ID).subscribe();
            } else {
              this._service
                .DeleteFileinMultipleFiles(element[0].ID)
                .subscribe();
            }
          }
          this.rows.value[i].OnboardHREmpDocs = this.MulFiles[i];
          if (this.MulFiles[i].length < 1) {
            this.rows.value[i].OnboardHREmpDocs = null;
          }
          this.toastr.success("Deleted Successfully");
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  getSubmitMyProfileData() {
    this.emp_svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
        if (this.disableforMyProfile == true) {
          this.EducationDetailForm.disable();
        }
      });
  }

  deleteFieldValue(index) {
    if (this.rows.value.length == 1) {
      this.toastr.warning("Minimum one testimonial is required");
      return;
    }
    const message = `Please confirm if you want to delete this Testimonial?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.rows.value.splice(index, 1);
          //console.log("======this.rows====", this.rows);
          this.MulFiles.splice(index, 1);
          //this.rows.value[i].OnboardHREmpDocs = this.MulFiles[i];
          var array = this.rows.value;
          this.rows = this.fb.array([]);
          this.EducationDetailForm = this.fb.group({ dates: this.rows });
          for (var i = 0; i < array.length; i++) {
            this.addItem(array[i]);
            this.rows.value[i].OnboardHREmpDocs = this.MulFiles[i];
          }
          this.myOutputVal.emit(this.rows);
          // this.getHREmpData();
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  openFileDialog(fileInput: any) {
    if (!this.fileInputOpen) {
      this.fileInputOpen = true;
      fileInput.open();
    }
  }

  FilesUploadDialogBox(index) {
    const message = this.rows.value[index];
    var screenName = "EducationTab";
    var count = 0;
    if (
      this.rows.value[index].OnboardHREmpDocs == "" ||
      this.rows.value[index].OnboardHREmpDocs == null
    ) {
      for (var i = 0; i < this.MulFiles.length; i++) {
        count += this.MulFiles[i].length;
      }
    } else {
      for (var i = 0; i < this.rows.value.length; i++) {
        count +=
          this.rows.value[i].OnboardHREmpDocs != null
            ? this.rows.value[i].OnboardHREmpDocs.length
            : 0;
      }
    }
    //this.rows.value[index].OnboardHREmpDocs == ""
    //  ? this.MulFiles[index].length + 1
    //  : this.rows.value[index].OnboardHREmpDocs != null && this.rows.value[index].OnboardHREmpDocs != "" ? this.rows.value[index].OnboardHREmpDocs.length + 1 : 1
    const dialogData = new MultipleFilesDialog(
      "Files Action",
      message,
      screenName,
      this.parentComponentName == "app-hr-employee-details"
        ? this.empCode
        : this.EmpId,
      count + 1,
      this.parentComponentName
    );
    const dialogRef = this.dialog.open(MultipleFilesDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult != false) {
          if (this.MulFiles[index] != null) {
            this.MulFiles[index] = this.MulFiles[index].concat(dialogResult);
            this.rows.value[index].OnboardHREmpDocs = this.MulFiles[index];
            this.cdr.detectChanges();
          } else {
            this.MulFiles[index] = dialogResult;
            this.rows.value[index].OnboardHREmpDocs = this.MulFiles[index];
            this.cdr.detectChanges();
          }
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  AdditionalFilesUploadDialogBox(index) {
    const message = this.additionalQualifications[index].Name;
    var screenName = "AdditionalDocuments";
    var count = 0;
    if (this.additionalQualifications != null) {
      for (var i = 0; i < this.additionalQualifications.length; i++) {
        count +=
          this.additionalQualifications[i].additionalDocs != null
            ? this.additionalQualifications[i].additionalDocs.length
            : 0;
      }
    }
    const dialogData = new MultipleFilesDialog(
      "Files Action",
      message,
      screenName,
      this.parentComponentName == "app-hr-employee-details"
        ? this.empCode
        : this.EmpId,
      count + 1,
      this.parentComponentName
    );
    const dialogRef = this.dialog.open(MultipleFilesDialogComponent, {
      maxWidth: "600px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult != false) {
          if (this.additionalQualifications[index].additionalDocs != null) {
            this.additionalQualifications[index].additionalDocs =
              this.additionalQualifications[index].additionalDocs.concat(
                dialogResult
              );
            this.cdr.detectChanges();
          } else {
            this.additionalQualifications[index].additionalDocs = dialogResult;
            this.cdr.detectChanges();
          }
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  addAdditionalQualItem() {
    this.additionalQualifications.push(this.newAttribute);
    this.newAttribute = {};
  }

  EmitOutputValues() {
    this.myOutputVal.emit(this.rows);
    this.additionalQual.emit(this.additionalQualifications);
  }

  deleteAdditionalQualification(index) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.additionalQualifications.splice(index, 1);
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  assignDocumentsListToObject() {
    for (var i = 0; i < this.MulFiles.length; i++) {
      this.rows.value[i].OnboardHREmpDocs = this.MulFiles[i];
    }
  }

  cancelFile(event, index, file, idx) {
    this.MulFiles[idx][index].File = null;
    this.rows.value[idx].OnboardHREmpDocs = this.MulFiles[idx];
    this.toastr.error("file removed successfully");
  }

  handleFile(event, index, file, idx) {
    if (event.target.files == undefined) {
      this.rows.value[index].OnboardHREmpDocs = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.MulFiles[idx][index].File = this.file_Svc.readAndUploadFile(files);
        this.rows.value[idx].OnboardHREmpDocs = this.MulFiles[idx];
        this.MulFiles[idx][index].DocumentPath = null;
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }
  //check the file types
  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }

  reset() {
    this.MulFiles = [];
  }

  handleFileAddtionalDoc(event, index, file, idx) {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      // Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.additionalQualifications[idx].additionalDocs[index].File =
          this.file_Svc.readAndUploadFile(files);
        this.additionalQualifications[idx].additionalDocs[index].DocumentPath =
          null;
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }

  cancelFileAddtionalDoc(event, index, file, idx) {
    this.additionalQualifications[idx].additionalDocs[index].File = null;
    // this.rows.value[idx].OnboardHREmpDocs = this.MulFiles[idx];
    this.toastr.error("file removed successfully");
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }
}
